import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import StickyMobileCTA from "@/components/StickyMobileCTA";

export default function Layout() {
    const location = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [location.pathname]);

    return (
        <div className="min-h-screen flex flex-col bg-bone text-ink">
            <Navbar />
            <main className="flex-1">
                <Outlet />
            </main>
            <Footer />
            <StickyMobileCTA />
        </div>
    );
}
